
document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  const header = document.querySelector('[data-ez-header]');
  const syncHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  syncHeader();
  window.addEventListener('scroll', syncHeader, {passive:true});
  document.querySelector('[data-menu-toggle]')?.addEventListener('click', () => menu?.classList.add('is-open'));
  document.querySelector('[data-menu-close]')?.addEventListener('click', () => menu?.classList.remove('is-open'));

  const root = document.querySelector('[data-product-root]:not([data-studioos-product])');
  if (root) {
    const variants = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const selects = [...root.querySelectorAll('[data-option-select]')];
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:'GBP'});
    const update = () => {
      const values = selects.map(s => s.value);
      const variant = variants.find(v => v.options.every((o, i) => o === values[i]));
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = money.format(variant.price / 100);
      const button = root.querySelector('button[type="submit"]');
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to bag' : 'Sold out';
    };
    selects.forEach(s => s.addEventListener('change', update));
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const rootRoute = window.Shopify?.routes?.root || '/';
  const cartAddRoute = `${rootRoute}cart/add.js`;
  const cartChangeRoute = `${rootRoute}cart/change.js`;
  const cartJsonRoute = `${rootRoute}cart.js`;
  const cartSectionRoute = `${rootRoute}cart?sections=ez-cart-drawer`;

  const drawer = () => document.querySelector('[data-cart-drawer]');
  const openAfterReloadKey = 'studioos-open-cart-after-first-add';
  let lastKnownCartCount = null;

  // Shopify only creates accelerated checkout buttons after a non-empty cart
  // exists. On the first add from an empty cart, initialise the newly inserted
  // component after it is connected to the live DOM. Quantity-only updates do
  // not call this function, so mounted wallet buttons remain untouched.
  const initialiseNewPaymentButtons = (scope = document) => {
    const wallet = scope.querySelector?.('.ez-accelerated-checkout');
    if (!wallet || wallet.dataset.paymentInitScheduled === 'true') return;

    wallet.dataset.paymentInitScheduled = 'true';
    const initialise = () => {
      try {
        window.Shopify?.PaymentButton?.init?.();
      } catch (error) {
        // The permanent standard checkout button remains available.
      }
    };

    requestAnimationFrame(() => {
      initialise();
      window.setTimeout(initialise, 120);
      window.setTimeout(() => {
        initialise();
        delete wallet.dataset.paymentInitScheduled;
      }, 450);
    });
  };

  const openDrawer = () => {
    const node = drawer();
    if (!node) return;

    // Sections can be rendered inside a sticky/transformed header or product
    // wrapper. Move the drawer to <body> so position:fixed always uses the
    // browser viewport rather than being clipped by the current template.
    if (node.parentElement !== document.body) document.body.appendChild(node);

    node.classList.add('is-open');
    node.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Shopify's wallet component can fail to initialise while the drawer is
    // hidden. On the first add to an empty basket, wait until the new drawer is
    // visible, then initialise only when no rendered wallet UI exists yet.
    requestAnimationFrame(() => {
      const wallet = node.querySelector('.ez-accelerated-checkout');
      const hasRenderedWallets = Boolean(
        wallet?.querySelector('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-cleanslate, iframe, button')
      );
      if (wallet && !hasRenderedWallets) initialiseNewPaymentButtons(node);
    });
  };


  // First-add wallet recovery: Shopify can return the freshly rendered cart
  // section before its accelerated-checkout markup is ready, especially in a
  // desktop theme preview. Re-request only the drawer footer while it is open
  // and only when the wallet region is missing or still empty.
  const ensureFirstAddPaymentButtons = async (attempt = 0) => {
    const node = drawer();
    if (!node || !node.classList.contains('is-open')) return;

    const existingWallet = node.querySelector('.ez-accelerated-checkout');
    const hasRenderedWallets = Boolean(
      existingWallet?.querySelector('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-cleanslate, iframe, button')
    );
    if (hasRenderedWallets) return;

    try {
      const response = await fetch(`${rootRoute}cart?sections=ez-cart-drawer&_=${Date.now()}`, {
        headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (response.ok) {
        const sections = await response.json();
        const html = sections['ez-cart-drawer'];
        if (html) {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const freshDrawer = parsed.querySelector('[data-cart-drawer]');
          const freshFooter = freshDrawer?.querySelector('.ez-cart-drawer__footer');
          const currentFooter = node.querySelector('.ez-cart-drawer__footer');
          const freshWallet = freshFooter?.querySelector('.ez-accelerated-checkout');
          if (freshFooter && currentFooter && freshWallet) {
            currentFooter.replaceWith(freshFooter);
            restoreDiscountCode(node);
            initialiseNewPaymentButtons(node);
          }
        }
      }
    } catch (error) {
      // Standard checkout remains available while Shopify catches up.
    }

    const wallet = node.querySelector('.ez-accelerated-checkout');
    const rendered = Boolean(
      wallet?.querySelector('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-cleanslate, iframe, button')
    );
    if (!rendered && attempt < 3) {
      window.setTimeout(() => ensureFirstAddPaymentButtons(attempt + 1), 300 + (attempt * 350));
    }
  };

  const closeDrawer = () => {
    const node = drawer();
    if (!node) return;
    node.classList.remove('is-open');
    node.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  const showCartFeedback = (message = 'Added to your bag') => {
    let toast = document.querySelector('.studioos-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'studioos-cart-toast';
      toast.innerHTML = '<strong></strong><span>Your basket has been updated.</span>';
      document.body.appendChild(toast);
    }
    toast.querySelector('strong').textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._timer);
    toast._timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);

    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.classList.remove('is-pulsing');
      void node.offsetWidth;
      node.classList.add('is-pulsing');
    });
  };

  const updateCartCountAndProgress = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
    });

    const progress = document.querySelector('[data-shipping-progress]');
    if (!progress) return;

    const threshold = Number(progress.dataset.threshold || 0);
    const remaining = Math.max(0, threshold - cart.total_price);
    const percentage = threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
    const bar = progress.querySelector('[data-shipping-bar]');
    const message = progress.querySelector('[data-shipping-message]');

    if (bar) bar.style.width = `${percentage}%`;
    if (message) {
      message.textContent = remaining > 0
        ? `${new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(remaining / 100)} away from free UK shipping`
        : 'You’ve unlocked free UK shipping';
    }
  };

  const getCart = async () => {
    const response = await fetch(cartJsonRoute, {
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Could not load basket');
    return response.json();
  };

  const applyDrawerHtml = (html, { keepOpen = true } = {}) => {
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector('[data-cart-drawer]');
    const current = drawer();
    if (!replacement || !current) return false;

    const wasOpen = keepOpen && current.classList.contains('is-open');
    current.replaceWith(replacement);
    restoreDiscountCode(replacement);
    if (wasOpen) openDrawer();
    return true;
  };

  const refreshDrawer = async ({ keepOpen = true, sectionHtml = '' } = {}) => {
    const wasOpen = keepOpen && drawer()?.classList.contains('is-open');

    // Apply Shopify's bundled section immediately for responsiveness, but do
    // not assume it is current. Some add routes can return the previous cart
    // section even though /cart.js already contains the newly added item.
    if (sectionHtml) applyDrawerHtml(sectionHtml, { keepOpen });

    const cart = await getCart();
    updateCartCountAndProgress(cart);

    const renderedCount = () => Number(drawer()?.dataset.cartItemCount ?? -1);
    let matchesLiveCart = renderedCount() === Number(cart.item_count);
    let replacement = null;

    // When the bundled section is stale (or missing), request a fresh section
    // until its rendered line count matches Shopify's live JSON cart.
    for (let attempt = 0; !matchesLiveCart && attempt < 5; attempt += 1) {
      const separator = cartSectionRoute.includes('?') ? '&' : '?';
      const response = await fetch(`${cartSectionRoute}${separator}_=${Date.now()}-${attempt}`, {
        headers: { Accept: 'application/json', 'Cache-Control': 'no-cache, no-store' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (response.ok) {
        const sections = await response.json().catch(() => ({}));
        const html = sections['ez-cart-drawer'];
        if (html) {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const candidate = parsed.querySelector('[data-cart-drawer]');
          const candidateCount = Number(candidate?.dataset.cartItemCount ?? -1);
          if (candidate) replacement = candidate;
          if (candidate && candidateCount === Number(cart.item_count)) {
            matchesLiveCart = true;
            break;
          }
        }
      }
      await new Promise((resolve) => window.setTimeout(resolve, 100 + (attempt * 130)));
    }

    const current = drawer();
    if (replacement && current) {
      current.replaceWith(replacement);
      restoreDiscountCode(replacement);
    }

    restoreDiscountCode(drawer() || document);
    if (keepOpen || wasOpen) openDrawer();
    return cart;
  };

  const changeLine = async (key, quantity, lineNode) => {
    const panel = drawer()?.querySelector('.ez-cart-drawer__panel');
    const requestedQuantity = Math.max(0, Number(quantity) || 0);
    lineNode?.classList.add('is-updating');
    panel?.setAttribute('aria-busy', 'true');

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);

    try {
      // Ask Shopify to mutate the cart and render the updated drawer in the
      // same response. This prevents remove/quantity actions from waiting on a
      // second section request that can stall or return one state behind.
      const response = await fetch(cartChangeRoute, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store'
        },
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
        body: JSON.stringify({
          id: key,
          quantity: requestedQuantity,
          sections: 'ez-cart-drawer',
          sections_url: window.location.pathname
        })
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result.description || result.message || 'Basket update failed');
      }

      updateCartCountAndProgress(result);
      lastKnownCartCount = result.item_count;

      const sectionHtml = result.sections?.['ez-cart-drawer'];
      if (sectionHtml) {
        applyDrawerHtml(sectionHtml, { keepOpen: true });
      } else {
        // Rare compatibility fallback for stores where bundled section
        // rendering is unavailable. This path is bounded and cannot leave the
        // drawer permanently loading.
        await refreshDrawer({ keepOpen: true });
      }

      showCartFeedback(requestedQuantity === 0 ? 'Removed from your bag' : 'Basket updated');
    } catch (error) {
      const message = error?.name === 'AbortError'
        ? 'The basket took too long to update. Please try again.'
        : (error.message || 'We could not update your basket. Please try again.');
      window.alert(message);
    } finally {
      window.clearTimeout(timeout);
      lineNode?.classList.remove('is-updating');
      drawer()?.querySelector('.ez-cart-drawer__panel')?.removeAttribute('aria-busy');
    }
  };

  const discountStorageKey = 'studioos-discount-code';

  const restoreDiscountCode = (scope = document) => {
    const saved = window.sessionStorage.getItem(discountStorageKey) || '';
    scope.querySelectorAll?.('[data-discount-input]').forEach((input) => {
      if (!input.value && saved) input.value = saved;
    });
  };

  const applyDiscountCode = async (block) => {
    const input = block?.querySelector('[data-discount-input]');
    const button = block?.querySelector('[data-discount-apply]');
    const message = block?.querySelector('[data-discount-message]');
    const code = input?.value.trim();

    block?.classList.remove('is-applied', 'has-error');
    if (!code) {
      block?.classList.add('has-error');
      if (message) message.textContent = 'Enter a discount code first.';
      input?.focus();
      return;
    }

    if (button) {
      button.disabled = true;
      button.textContent = 'Applying…';
    }

    try {
      const discountUrl = `${rootRoute}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(rootRoute + 'cart')}`;
      const response = await fetch(discountUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        redirect: 'follow'
      });
      if (!response.ok) throw new Error('Discount could not be applied');

      window.sessionStorage.setItem(discountStorageKey, code);
      document.querySelectorAll('[data-discount-input]').forEach((field) => { field.value = code; });
      block?.classList.add('is-applied');
      if (message) message.textContent = 'Code saved — Shopify will confirm it at checkout.';
    } catch (error) {
      block?.classList.add('has-error');
      if (message) message.textContent = 'We could not apply that code. Please check it and try again.';
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = 'Apply';
      }
    }
  };

  restoreDiscountCode();

  // Keep standard checkout separate from the cart POST. On iOS Safari,
  // submitting the discount input with the /cart form can be returned as a
  // zero-byte file named "cart". Navigate through Shopify's supported
  // discount route instead, then continue directly to checkout.
  document.addEventListener('submit', (event) => {
    const checkoutForm = event.target.closest('.ez-cart-checkout-form, .ez-cart-page form');
    const submitter = event.submitter;
    if (!checkoutForm || submitter?.name !== 'checkout') return;

    event.preventDefault();
    const visibleCode = checkoutForm.querySelector('[data-discount-input]')?.value.trim();
    const savedCode = window.sessionStorage.getItem(discountStorageKey) || '';
    const code = visibleCode || savedCode;
    const checkoutUrl = `${rootRoute}checkout`;

    if (code) {
      window.sessionStorage.setItem(discountStorageKey, code);
      const discountCheckoutUrl = `${rootRoute}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(checkoutUrl)}`;
      window.location.assign(discountCheckoutUrl);
    } else {
      window.location.assign(checkoutUrl);
    }
  });

  document.addEventListener('click', (event) => {
    const discountButton = event.target.closest('[data-discount-apply]');
    if (discountButton) {
      event.preventDefault();
      applyDiscountCode(discountButton.closest('[data-discount-code]'));
      return;
    }

    const openButton = event.target.closest('[data-cart-open]');
    if (openButton) {
      event.preventDefault();
      // The server-rendered drawer is already current on page load. Avoid
      // rebuilding it merely because it was opened, which can reset Shopify's
      // accelerated checkout components.
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      const line = removeButton.closest('[data-line-key]');
      if (line?.dataset.lineKey) changeLine(line.dataset.lineKey, 0, line);
      return;
    }

    const minus = event.target.closest('[data-cart-drawer] [data-qty-minus]');
    const plus = event.target.closest('[data-cart-drawer] [data-qty-plus]');
    if (minus || plus) {
      event.preventDefault();
      const line = event.target.closest('[data-line-key]');
      const input = line?.querySelector('[data-qty-input]');
      if (!line?.dataset.lineKey || !input) return;
      const current = Math.max(0, Number(input.value) || 0);
      const next = plus ? current + 1 : Math.max(0, current - 1);
      input.value = String(next);
      changeLine(line.dataset.lineKey, next, line);
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-drawer] [data-qty-input]');
    if (!input) return;
    const line = input.closest('[data-line-key]');
    if (!line?.dataset.lineKey) return;
    changeLine(line.dataset.lineKey, input.value, line);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer()?.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('studioos:cart:refresh', async (event) => {
    const shouldOpen = event.detail?.open !== false;
    try {
      // Refresh the rendered drawer from Shopify's cart route immediately after
      // every AJAX add. This avoids the desktop race where the item exists in
      // /cart.js but the visible drawer still shows its previous empty markup.
      const beforeCount = lastKnownCartCount;
      const cart = await refreshDrawer({
        keepOpen: shouldOpen,
        sectionHtml: event.detail?.sectionHtml || ''
      });
      const isFirstAdd = (beforeCount === 0 || beforeCount === null) && cart.item_count > 0;
      lastKnownCartCount = cart.item_count;

      if (shouldOpen) openDrawer();
      showCartFeedback(event.detail?.message || 'Added to your bag');

      // Initialise accelerated checkout after the updated drawer is already
      // visible. Do not reload the page: a reload could interrupt the desktop
      // variant-list add flow before the customer sees the basket update.
      if (isFirstAdd) {
        initialiseNewPaymentButtons(drawer() || document);
        window.setTimeout(() => ensureFirstAddPaymentButtons(), 180);
      }
    } catch (error) {
      const cart = await getCart().catch(() => null);
      if (cart) {
        lastKnownCartCount = cart.item_count;
        updateCartCountAndProgress(cart);
      }
      if (shouldOpen) openDrawer();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.ez-card__form');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const original = button?.textContent;

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    try {
      const formData = new FormData(form);
      formData.set('sections', 'ez-cart-drawer');
      formData.set('sections_url', `${rootRoute}cart`);
      const response = await fetch(cartAddRoute, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
        credentials: 'same-origin',
        cache: 'no-store',
        body: formData
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || 'Could not add item');

      document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {
        detail: {
          open: true,
          source: 'product-card',
          message: 'Product added to your bag',
          sectionHtml: payload.sections?.['ez-cart-drawer'] || ''
        }
      }));
      if (button) button.textContent = 'Added ✓';
    } catch (error) {
      if (button) button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      }, 1400);
    }
  });

  // StudioOS unified bridge for components that do not submit the standard
  // .ez-card__form. Product-page forms, bulk ordering and Featured Collection
  // retain their proven handlers; only card buttons, Recently Viewed and Trade
  // Order are routed through this bridge.
  let componentAddBusy = false;

  const addItemsFromComponent = async (items, { source = 'component', message = 'Product added to your bag' } = {}) => {
    const cleanItems = (Array.isArray(items) ? items : [items])
      .map((item) => ({ id: Number(item.id), quantity: Math.max(1, Number(item.quantity || 1)) }))
      .filter((item) => item.id > 0 && item.quantity > 0);
    if (!cleanItems.length) throw new Error('No available product was selected');

    const response = await fetch(cartAddRoute, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'Cache-Control': 'no-cache, no-store' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify({
        items: cleanItems,
        sections: ['ez-cart-drawer'],
        sections_url: `${rootRoute}cart`
      })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || payload.message || 'Could not add product');

    document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {
      detail: {
        open: true,
        source,
        message,
        sectionHtml: payload.sections?.['ez-cart-drawer'] || ''
      }
    }));
    return payload;
  };

  document.addEventListener('click', async (event) => {
    const cardButton = event.target.closest('[data-card-add-button]');
    const recentButton = event.target.closest('[data-recent-add]');
    const tradeButton = event.target.closest('[data-quick-order-add]');
    if (!cardButton && !recentButton && !tradeButton) return;

    // Prevent legacy component scripts from also submitting the same click.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (componentAddBusy) return;

    const button = cardButton || recentButton || tradeButton;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    componentAddBusy = true;

    try {
      if (cardButton) {
        const block = cardButton.closest('[data-card-quick-add]');
        const variant = block?.querySelector('[data-quick-add-variant]');
        const quantity = block?.querySelector('[data-card-qty-input]');
        await addItemsFromComponent({ id: variant?.value, quantity: quantity?.value || 1 }, {
          source: 'card-quick-add', message: 'Product added to your bag'
        });
      } else if (recentButton) {
        await addItemsFromComponent({ id: recentButton.dataset.recentAdd, quantity: 1 }, {
          source: 'recently-viewed', message: 'Product added to your bag'
        });
      } else {
        const scope = tradeButton.closest('[data-sos-quick-order]') || document;
        const items = [...scope.querySelectorAll('[data-variant-qty]')]
          .map((input) => ({ id: input.dataset.variantId, quantity: Number(input.value || 0) }))
          .filter((item) => item.quantity > 0);
        await addItemsFromComponent(items, {
          source: 'trade-order', message: 'Selected products added to your bag'
        });
        scope.querySelectorAll('[data-variant-qty]').forEach((input) => { input.value = '0'; });
        scope.querySelector('[data-quick-order-basket]')?.setAttribute('hidden', '');
      }
      button.textContent = 'Added ✓';
    } catch (error) {
      console.error('[StudioOS component add]', error);
      button.textContent = 'Try again';
      window.alert(error.message || 'We could not add that product. Please try again.');
    } finally {
      componentAddBusy = false;
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = original;
      }, 1300);
    }
  }, true);

  document.querySelector('[data-mobile-atc]')?.addEventListener('click', () => {
    document.querySelector('.ez-product-form button[type="submit"]')?.click();
  });

  const recommendations = document.querySelector('[data-recommendations]');
  if (recommendations) {
    fetch(`${rootRoute}recommendations/products?section_id=ez-product-recommendations&product_id=${recommendations.dataset.productId}&limit=${recommendations.dataset.limit}&intent=related`)
      .then((response) => response.text())
      .then((html) => {
        const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
        if (replacement) recommendations.innerHTML = replacement.innerHTML;
      })
      .catch(() => {});
  }

  getCart().then((cart) => {
    lastKnownCartCount = cart.item_count;
    updateCartCountAndProgress(cart);
    if (window.sessionStorage.getItem(openAfterReloadKey) === '1') {
      window.sessionStorage.removeItem(openAfterReloadKey);
      requestAnimationFrame(() => {
        openDrawer();
        initialiseNewPaymentButtons(drawer() || document);
      });
    }
  }).catch(() => {});
});


/* StudioOS v0.9.7.1 — dynamically-loaded recommendations controls */
document.addEventListener('click', (event) => {
  const prev = event.target.closest('[data-recommendations-prev]');
  const next = event.target.closest('[data-recommendations-next]');
  if (!prev && !next) return;

  const section = event.target.closest('[data-recommendations]');
  const scroller = section?.querySelector('[data-recommendations-scroller]');
  if (!scroller) return;

  const firstItem = scroller.querySelector('.ez-recommendations__item');
  const gap = parseFloat(getComputedStyle(scroller).gap || '0');
  const amount = firstItem
    ? firstItem.getBoundingClientRect().width + gap
    : Math.max(260, scroller.clientWidth * .82);

  scroller.scrollBy({
    left: next ? amount : -amount,
    behavior: 'smooth'
  });
});

document.addEventListener('wheel', (event) => {
  const scroller = event.target.closest('[data-recommendations-scroller]');
  if (!scroller) return;

  const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY)
    ? event.deltaX
    : event.deltaY;

  if (!delta) return;

  event.preventDefault();
  scroller.scrollLeft += delta;
}, { passive: false });


/* StudioOS v0.9.8.6 — desktop drag for recommendations */
(() => {
  let scroller = null;
  let startX = 0;
  let startScroll = 0;
  let moved = false;

  document.addEventListener('mousedown', (event) => {
    const target = event.target.closest('[data-recommendations-scroller]');
    if (!target || event.button !== 0) return;
    if (event.target.closest('button,input,select,textarea,label')) return;

    scroller = target;
    startX = event.clientX;
    startScroll = target.scrollLeft;
    moved = false;
    target.classList.add('is-desktop-dragging');
  });

  document.addEventListener('mousemove', (event) => {
    if (!scroller) return;
    const dx = event.clientX - startX;
    if (Math.abs(dx) > 6) moved = true;
    event.preventDefault();
    scroller.scrollLeft = startScroll - dx;
  }, { passive:false });

  document.addEventListener('mouseup', () => {
    if (!scroller) return;
    scroller.classList.remove('is-desktop-dragging');
    if (moved) {
      scroller.dataset.blockClick = 'true';
      setTimeout(() => {
        if (scroller) delete scroller.dataset.blockClick;
      }, 250);
    }
    scroller = null;
  });

  document.addEventListener('click', (event) => {
    const rail = event.target.closest('[data-recommendations-scroller]');
    if (!rail || rail.dataset.blockClick !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    delete rail.dataset.blockClick;
  }, true);
})();
